export default __webpack_public_path__ + "static/media/user.8d9d5ddd.png";